import cloud from "../../../../asset/cloud(2).png";
import ufo from "../../../../asset/ufo.png";


export const cashConfig: any = [
  {
    cash_position:[-1.15, 2.3, 0.1],
    cash_size:[0.4, 0.4],
    type:'coin',
    ref:"moneyRef"
  },
  {
    cash_position:[-1.15, 2.2, 0],
    cash_size:[0.3, 0.3],
    type:'coin',
    ref:"money2Ref"
  },
  {
    cash_position:[-1.15, 2.2, 0],
    cash_size:[0.3, 0.3],
    type:'coin',
    ref:"money3Ref"
  },
  {
    cash_position:[-1.15, 2.2, 0],
    cash_size:[0.3, 0.3],
    type:'cash',
    ref:"cashRef"
  },
  {
    cash_position:[-1.15, 2.2, 0],
    cash_size:[0.4, 0.4],
    type:'cash',
    ref:"cash2Ref"
  }
]



export const cloudConfig: any = [
  {
    cloud_position_sm:[2, 0.9, 0.4],
    cloud_position_lg:[2, 1.189, 0.4],
    cloud_size:[1.5, 0.5],
    type:cloud,
    ref:'cloudRef'
  },{
    cloud_position_sm:[2, 1.25, 0.4],
    cloud_position_lg:[-1, 1.58, 0.4],
    cloud_size:[1.5, 0.5],
    type:cloud,
    ref:'anotherCloudRef'
  }]


  export const ufoConfig:any = {
    position:[1.8, -1.5, 1],
    size:[1, 1.5],
    type:ufo
  }

  export const profileConfig:any = {
    position:[1.8, -1.5, 1],
    size:[0.2, 0.2],
    type:cloud
  }